import { Injectable } from "@angular/core";
import { FormControl } from "@angular/forms";

Injectable()
export class FormService {

    forms?: Record<string, FormControl>;
    displayOtherTextbox?: boolean;

    /**
     * Shows the 'Other' textbox by updating the service property 'displayOtherTextbox'. The UI will toggle the box
     * based on this property.
     */
    showOtherTextbox() {
        this.displayOtherTextbox = true;
    }

    /**
     * Hides the 'Other' textbox by updating the service property 'displayOtherTextbox'. The UI will toggle the box
     * based on this property.
     */
    hideOtherTextbox() {
        this.displayOtherTextbox = false;
    }
}
